if (!customElements.get('tww-bundle-contents')) {
  customElements.define('tww-bundle-contents', class extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-bundle-variant-data]').textContent);
      this.scope = this.closest('product-info');
      this.onChange = () => this.render(this.formVariant());
      this.onHistory = () => {
        const id = new URL(location.href).searchParams.get('variant');
        const variant = this.variants.find(v => String(v.id) === id);
        const picker = this.scope?.querySelector('variant-radios, variant-selects');
        if (variant && picker && String(this.formVariant()) !== id) {
          if (picker.matches('variant-radios')) {
            picker.querySelectorAll('fieldset').forEach((fieldset, i) => {
              fieldset.querySelectorAll('input[type="radio"]').forEach(input => {
                input.checked = input.value === variant.options[i];
              });
            });
          } else {
            picker.querySelectorAll('select').forEach((select, i) => {
              select.value = variant.options[i];
            });
          }
          picker.dispatchEvent(new Event('change', {bubbles: true}));
        }
        this.render(this.formVariant());
      };
      this.scope?.addEventListener('change', this.onChange);
      window.addEventListener('popstate', this.onHistory);
      window.addEventListener('pageshow', this.onHistory);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          if (event.data.sectionId === this.dataset.sectionId) this.render(event.data.variant?.id);
        });
      }
      this.render(this.formVariant());
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('change', this.onChange);
      window.removeEventListener('popstate', this.onHistory);
      window.removeEventListener('pageshow', this.onHistory);
      this.unsubscribe?.();
    }
    formVariant() {
      return document.getElementById(this.dataset.formId)?.querySelector('[name="id"]')?.value
        || this.dataset.initialVariant;
    }
    render(id) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      let count = 0;
      this.querySelectorAll('[data-bundle-variants]').forEach(item => {
        const ids = item.dataset.bundleVariants.split(',').map(value => value.trim());
        item.hidden = !variant || !ids.includes(String(id));
        if (!item.hidden) count++;
      });
      this.querySelector('[data-bundle-title]').textContent = variant?.title || '';
      this.querySelector('[data-bundle-count]').textContent = count;
      this.querySelector('[data-bundle-fallback]').hidden = count > 0;
      this.dataset.selectedVariant = variant ? String(variant.id) : '';
    }
  });
}
